"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSettings = exports.getPeriodType = exports.PeriodType = void 0;
var PeriodType;
(function (PeriodType) {
    PeriodType["Quarters"] = "quarters";
    PeriodType["Halves"] = "halves";
})(PeriodType = exports.PeriodType || (exports.PeriodType = {}));
// Utility function to get the periodType from GameSettingsDoc
function getPeriodType(settings) {
    var _a;
    if (settings.hoops) {
        return (_a = settings.hoops) === null || _a === void 0 ? void 0 : _a.periodType;
    }
    // Add other sports checks here
    return undefined;
}
exports.getPeriodType = getPeriodType;
var GameSettings;
(function (GameSettings) {
    function fromHoopsMap(gameSettings) {
        if (gameSettings) {
            return {
                hoops: {
                    gameClock: gameSettings.get('gameClock'),
                    periodType: gameSettings.get('periodType'),
                    periodLength: gameSettings.get('periodLength'),
                    teamTimeouts: gameSettings.get('teamTimeouts'),
                    timeoutsReset: gameSettings.get('timeoutsReset'),
                },
            };
        }
        return GameSettings.emptyGameSettingsDoc();
    }
    GameSettings.fromHoopsMap = fromHoopsMap;
    function emptyGameSettingsDoc() {
        return {
            hoops: undefined,
        };
    }
    GameSettings.emptyGameSettingsDoc = emptyGameSettingsDoc;
})(GameSettings = exports.GameSettings || (exports.GameSettings = {}));
//# sourceMappingURL=definitions.js.map